export class CatalogModalController {
  observeClose(modalId: string, onClosed: () => void): MutationObserver | undefined {
    const modalElement = document.getElementById(modalId);
    if (!modalElement) {
      return undefined;
    }

    // KT modals rely on class/style/aria changes; observe all three to detect true close transitions.
    let wasVisible = this.isModalVisible(modalElement);

    const observer = new MutationObserver(() => {
      const isVisible = this.isModalVisible(modalElement);
      if (wasVisible && !isVisible) {
        onClosed();
      }
      wasVisible = isVisible;
    });

    observer.observe(modalElement, {
      attributes: true,
      attributeFilter: ['class', 'style', 'aria-hidden'],
    });

    return observer;
  }

  open(modalId: string): void {
    const triggerButton = document.querySelector(
      `[data-kt-modal-toggle="#${modalId}"]`,
    ) as HTMLButtonElement | null;

    triggerButton?.click();
  }

  close(modalId: string): void {
    const modalElement = document.getElementById(modalId);
    if (modalElement) {
      const modalInstance = window.KTModal?.getInstance?.(modalElement)
        ?? window.KTModal?.getOrCreateInstance?.(modalElement);
      if (modalInstance) {
        modalInstance.hide();
        return;
      }
    }

    const closeButton = document.querySelector(
      `#${modalId} [data-kt-modal-dismiss="#${modalId}"]`,
    ) as HTMLButtonElement | null;

    requestAnimationFrame(() => closeButton?.click());
  }

  private isModalVisible(modalElement: HTMLElement): boolean {
    if (modalElement.classList.contains('hidden') || modalElement.getAttribute('aria-hidden') === 'true') {
      return false;
    }

    const computedStyle = window.getComputedStyle(modalElement);
    return computedStyle.display !== 'none' && computedStyle.visibility !== 'hidden';
  }
}
